import { Component, Inject, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { Sgke050dRegistComponent } from '../sgke050d-regist/sgke050d-regist.component';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';

@Component({
  selector: 'app-sgke050d-dialog',
  templateUrl: './sgke050d-dialog.component.html',
  styleUrl: './sgke050d-dialog.component.scss'
})
export class Sgke050dDialogComponent implements OnInit, OnDestroy {
  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();

  @ViewChild(Sgke050dRegistComponent) sgke050dRegistComponent!: Sgke050dRegistComponent;

  /**
   * コンストラクタ
   * @param {{ kinkoMno: string, kinkoRrkno: string, repayMno: string, recptFixNo: string }} data
   * @param {MatDialog} dialog
   * @param {ResponseMsgUtils} responseMsgUtils
   * @memberof Sgke050dDialogComponent
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { kinkoMno: string, kinkoRrkno: string, repayMno: string, recptFixNo: string, kinkoUpdateSrno: string, kinkoexUpdatesequencenumber: string },
    public dialog: MatDialog,
    public responseMsgUtils: ResponseMsgUtils,
  ) {
  }

  /**
   * 初期処理
   * @memberof Sgke050dComponent
   */
  ngOnInit(): void {
  }


  /**
   * 購読解除
   * @memberof Sgke050dComponent
   */
  ngOnDestroy() {
  }

  /*
   * 閉じるボタン押下時処理
   * @memberof Sgke050dDialogComponent
   */
  onClickClose() {
    this.dialog.closeAll();
  }

  /**
    * メッセージ表示
    * @memberof Sgke050dComponent
    */
  showMsg(errors) {
    // メッセージを表示
    this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(errors, this.errorMessageModelArray);
  }



}
